export default (name, action) => {
  action.toString = () => name

  return action
}
